export default __webpack_public_path__ + "static/media/pdf.4cdde51d.svg";